import React, { useState } from "react";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faThumbsUp,
  faThumbsDown,
  faMeh,
} from "@fortawesome/pro-light-svg-icons";
import {
  faThumbsUp as faThumbsUpSolid,
  faThumbsDown as faThumbsDownSolid,
  faMeh as faMehSolid,
} from "@fortawesome/pro-solid-svg-icons";

const FeedbackContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  transition: opacity 0.2s ease;
  padding: 4px 0;
`;

const FeedbackButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  color: ${(props) =>
    props.isSelected
      ? props.selectedColor || props.theme.primary
      : props.theme.text.secondary || "#666"};

  &:hover {
    background-color: ${(props) =>
      props.theme.type === "light"
        ? props.theme.gray?.gray200 || "#f5f5f5"
        : props.theme.gray?.gray800 || "#2a2a2a"};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

const feedbackOptions = [
  {
    type: "thumbs_up",
    icon: faThumbsUp,
    solidIcon: faThumbsUpSolid,
    title: "Good response",
    color: "#10b981",
  },
  {
    type: "neutral",
    icon: faMeh,
    solidIcon: faMehSolid,
    title: "Neutral",
    color: "#f59e0b",
  },
  {
    type: "thumbs_down",
    icon: faThumbsDown,
    solidIcon: faThumbsDownSolid,
    title: "Bad response",
    color: "#ef4444",
  },
];

export default function MessageFeedback({
  messageId,
  conversationId,
  currentFeedback,
  onFeedbackSubmit,
  onThumbsDown,
  isHovered,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleFeedback = async (feedbackType) => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      await onFeedbackSubmit(messageId, conversationId, feedbackType);
      if (feedbackType === "thumbs_down" && onThumbsDown) {
        onThumbsDown(messageId);
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  const isVisible = isHovered || !!currentFeedback;

  return (
    <FeedbackContainer isVisible={isVisible}>
      {feedbackOptions.map((option) => {
        const isSelected = currentFeedback === option.type;
        return (
          <FeedbackButton
            key={option.type}
            onClick={() => handleFeedback(option.type)}
            disabled={isSubmitting}
            isSelected={isSelected}
            selectedColor={option.color}
            title={option.title}
          >
            <FontAwesomeIcon
              icon={isSelected ? option.solidIcon : option.icon}
            />
          </FeedbackButton>
        );
      })}
    </FeedbackContainer>
  );
}
